export default __webpack_public_path__ + "static/slider3-19f33f00a38ed8601f84882997daef3f.png";